module.exports = __webpack_public_path__ + "static/img/1.a16825f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Proteccion-digital-Empresas/1.png
// module id = 25FM
// module chunks = 0